var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17293 13.8399L4.21053 22.5346L10.2556 22.6974V21.46H8.57143L11.8496 15.5332L16.4812 24L19.5789 18.7246L18.5865 18.0081L17.6541 19.5712L14.7669 14.0353H24L20.9925 8.3365L19.8797 8.98779L20.6917 10.5509H14.3759L19.1579 1.82361H13.1128V2.99593H14.9173L12.0602 8.53189L7.69925 0L4.51128 5.27544L5.47368 5.92673L6.22556 4.62415L9.26316 10.4206H0L2.76692 15.9891L3.78947 15.2727L3.12782 13.8399H9.17293ZM6.97745 3.45183L11.2076 11.6581H1.86466L2.43609 12.7653H10.7771L6.0752 21.46H7.24813L11.8689 12.941L16.3609 21.6554L16.9925 20.6459L12.9734 12.7653H21.9248L21.3835 11.6581H12.5647L17.2632 2.99593H16.0602L11.9074 10.6751L7.60902 2.24695L6.97745 3.45183Z",
    fill: "#F45C24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/mainLogo.defcb22e23fcf899fd176fd518bce685.svg";
export { ForwardRef as ReactComponent };